export const environment = {
  production: true,
  apiUrl: 'https://klusdesign.com/api',
  pageUrl: 'https://klusdesign.com'
 };
